import React from "react";
import { Card, Tag } from "antd";
import { motion } from "framer-motion";
import mail from "../../../../assets/images/email.svg";
import Linkedin from "../../../../assets/images/linkedIn.svg";
import Wysisyg from "../../Wysisyg";
import LinkOutlined from "../../../../assets/newImages/LinkOutlined.svg";
import { formatEventDateRange, getEventCountryDisplay } from "../../../../utils/helper";
import countryData from "../../../../json/countries.json";
import './InfoCard.scss';
import ReactCountryFlag from "react-country-flag"

const hasText = (value) => Boolean(value && String(value).trim());

const normalizeExternalUrl = (url) => {
  if (!hasText(url)) return "";
  const trimmed = String(url).trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

const EventDetailRow = ({ label, children }) => (
  <div className="type pointers event-details-row">
    <div className="listInfoRow">
      <div className="listInfoCol"><p className="pointer-headers">{label}</p></div>
      <div className="listInfoCol">{children}</div>
    </div>
  </div>
);

const InfoCard = ({ state = {}, jobTypeTitle, disable }) => {

  return (
    <motion.div
      className="microsite-info-card-container  spl-container"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="site-card-border-less-wrapper">
        <Card
          style={{
            // boxShadow:"0px 4px 12px rgba(0, 0, 0, 0.25)",
          }}
          // title={handleCardTitle({ state })}
          bordered={state?.page === "ACCREDITATIONS_AWARDS" ? false : true}
        >
          {state?.page === "ACCREDITATIONS_AWARDS" &&
            <h6 className="title-header">
              {"Award"}
            </h6>
          }

          {state?.page === "news_tab" ? (
            <Wysisyg state={state} />
          ) : state?.page === "events" ? (
            <div className="listInfoBox event-details-info">
              {hasText(state?.data?.eventName) && (
                <h6 className="title-header title-header-micro">
                  {state.data.eventName}
                </h6>
              )}
              {hasText(state?.data?.description) && (
                <div className="micro-descrp" style={{ whiteSpace: "pre-wrap" }}>
                  <p>{state.data.description}</p>
                </div>
              )}
              {(() => {
                const dateRange = formatEventDateRange(state?.data?.startDate, state?.data?.endDate);
                return dateRange ? (
                  <EventDetailRow label="Date:">
                    <p>{dateRange}</p>
                  </EventDetailRow>
                ) : null;
              })()}
              {hasText(state?.data?.moreInfo) && (
                <EventDetailRow label="More info:">
                  <p>{state.data.moreInfo}</p>
                </EventDetailRow>
              )}
              {normalizeExternalUrl(state?.data?.webLink) && (
                <EventDetailRow label="Find out more:">
                  <a
                    className="event-details-link"
                    href={normalizeExternalUrl(state.data.webLink)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {state.data.webLink}
                  </a>
                </EventDetailRow>
              )}
              {(() => {
                const countryDisplay = getEventCountryDisplay(state?.data?.country, countryData);
                return countryDisplay ? (
                  <EventDetailRow label="Country:">
                    <p className="event-details-country">

                      {/* <span className="event-details-country-flag" aria-hidden="true">{countryDisplay.flag}</span> */}
                      <ReactCountryFlag countryCode={state?.data?.country} svg />
                      <span className="event-details-country-name">{countryDisplay.name}</span>
                    </p>
                  </EventDetailRow>
                ) : null;
              })()}
              {hasText(state?.data?.address) && (
                <EventDetailRow label="Address:">
                  <p>{state.data.address}</p>
                </EventDetailRow>
              )}
              {normalizeExternalUrl(state?.data?.venueLink) && (
                <EventDetailRow label="Venue website:">
                  <a
                    className="event-details-link"
                    href={normalizeExternalUrl(state.data.venueLink)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {state.data.venueLink}
                  </a>
                </EventDetailRow>
              )}
              {normalizeExternalUrl(
                typeof state?.data?.mediaLink === "string"
                  ? state.data.mediaLink
                  : state?.data?.mediaLink?.url
              ) && (
                  <EventDetailRow label="Media link:">
                    <a
                      className="anchor"
                      href={normalizeExternalUrl(
                        typeof state.data.mediaLink === "string"
                          ? state.data.mediaLink
                          : state.data.mediaLink.url
                      )}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {typeof state.data.mediaLink === "string"
                        ? state.data.mediaLink
                        : state.data.mediaLink.url}
                    </a>
                  </EventDetailRow>
                )}
              {hasText(state?.data?.gifInput) && (
                <EventDetailRow label="GIF:">
                  <p>{state.data.gifInput}</p>
                </EventDetailRow>
              )}
            </div>
          ) : (
            <div className="listInfoBox">
              {(state?.data?.title ||
                state?.data?.subTitle ||
                state?.data?.experienceOfWorkTitle) && (
                  <h6 className="title-header title-header-micro ">
                    {(() => {
                      const transformTitle = (title) => {
                        if (title === "WhyDo") {
                          return "Why we exist";
                        }
                        if (title === "whatDo") {
                          return "What we do";
                        }
                        if (title === "howDo") {
                          return "How we help clients";
                        }
                        return title;
                      };

                      return (
                        transformTitle(state?.data?.title) ??
                        state?.data?.subTitle ??
                        state?.data?.experienceOfWorkTitle
                      );
                    })()}
                  </h6>
                )}
              {(state?.data?.description ||
                state?.data?.experienceOfWorkOpportunityOutput
                  ?.description) && (
                  <div
                    className="micro-descrp"
                    style={{ whiteSpace: "pre-wrap" }}
                  >
                    <p>
                      {state?.data?.description ??
                        state?.data?.experienceOfWorkOpportunityOutput
                          ?.description}
                    </p>
                  </div>
                )}
            </div>
          )}

          {state?.page === "apprenticeship" || state?.page === "vacancy" ? (
            <div className="listInfoBox">
              {state?.page === "apprenticeship" && <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol">
                    <p className="pointer-headers">
                      {/* {state?.page === "apprenticeship"
                        ? "Apprenticeship type:"
                        : "Vacancy type:"} */}
                      Apprenticeship type:
                    </p>
                  </div>
                  <div className="listInfoCol">
                    <p>
                      {state?.data?.apprenticeshipType === "PART_TYPE"
                        ? "Part Time"
                        : "Full Time"}
                    </p>
                  </div>
                </div>
              </div>}

              {state?.data?.jobTypeEnum &&
                jobTypeTitle(state?.data?.jobTypeEnum) && (
                  <div className="type pointers">
                    <div className="listInfoRow">
                      <div className="listInfoCol"><p className="pointer-headers">Job type:</p></div>
                      <div className="listInfoCol"><p>{jobTypeTitle(state?.data?.jobTypeEnum)}</p></div>
                    </div>


                  </div>
                )}

              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol"><p className="pointer-headers">Salary:</p></div>
                  <div className="listInfoCol"><p>{state?.data?.compensation}</p></div>
                </div>


              </div>

              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol"><p className="pointer-headers">Salary type:</p></div>
                  <div className="listInfoCol">
                    <p>
                      {state?.data?.compensationType === "ANNUALLY"
                        ? "Annually"
                        : "Annually"}
                    </p>
                  </div>
                </div>


              </div>

              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol"> <p className="pointer-headers">Closing date:</p></div>
                  <div className="listInfoCol"> <p>{state?.data?.closingDate?.split("-").reverse().join("/")}</p></div>
                </div>


              </div>

              <div
                className="type skills"
                style={{ display: "flex", alignItems: "center", marginBottom: '10px' }}
              >
                <div className="listInfoRow">
                  <div className="listInfoCol"><p className="skillsLabel pointer-headers">Skills:</p></div>
                  <div className="listInfoCol">
                    <div className="skillTags">
                      {state?.data?.skills.map((skill) => (
                        <Tag style={{ marginBottom: '10px' }} color="red" key={skill.name}>
                          {skill.name}
                        </Tag>
                      ))}
                    </div>
                  </div>
                </div>


              </div>
            </div>
          ) : null}

          {state?.page === "contract" && (
            <div>
              {state?.data?.procurementReference && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Procurement Reference:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.procurementReference}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.postalCode && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Postal code:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.postalCode}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.valueOfContract !== 0 && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Value Of Contract:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.valueOfContract}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.startDate && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Start date:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.startDate}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.endDate && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">End date:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.endDate}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.closeDate && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Close date:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.closeDate}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.closeTime && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Close time:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.closeTime}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.contractType && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Contract Type:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.contractType}</p></div>
                  </div>


                </div>
              )}
              {state?.data?.email && (
                <div className="type pointers">
                  <div className="listInfoRow">
                    <div className="listInfoCol"><p className="pointer-headers">Email:</p></div>
                    <div className="listInfoCol"><p>{state?.data?.email}</p></div>
                  </div>


                </div>
              )}
            </div>
          )}

          {(state?.page === "OUR_TEAM" || state?.page === "OUR_CLIENT" || state?.page === "OUR_SUPPORTERS") &&
            state?.data?.aboutUsTeamDataOutPut?.linkedin && (
              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol labelCol">
                    <div className="labelContent">
                      <img src={state?.page === "OUR_TEAM" ? Linkedin : LinkOutlined} alt="LinkedIn" className="icon" />
                      {/* <span className="pointer-headers">Link:</span> */}
                    </div>
                  </div>
                  <div className="listInfoCol valueCol">
                    <a
                      className="anchor"
                      href={state?.data?.aboutUsTeamDataOutPut?.linkedin}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {state?.data?.aboutUsTeamDataOutPut?.linkedin}
                    </a>
                  </div>
                </div>
              </div>
            )}

          {(state?.page === "OUR_TEAM" || state?.page === "OUR_CLIENT" || state?.page === "OUR_SUPPORTERS") &&
            state?.data?.aboutUsTeamDataOutPut?.email && (
              <div className="type pointers">
                <div className="listInfoRow">
                  <div className="listInfoCol labelCol">
                    <div className="labelContent">
                      <img src={mail} alt="Email" className="icon" />
                      {/* <span className="pointer-headers">Email:</span> */}
                    </div>
                  </div>
                  <div className="listInfoCol valueCol">
                    <a
                      className="anchor"
                      href={`mailto:${state?.data?.aboutUsTeamDataOutPut?.email}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {state?.data?.aboutUsTeamDataOutPut?.email}
                    </a>
                  </div>
                </div>
              </div>
            )}

          {/* <div style={{ display: "flex", justifyContent: "end" }}>
            {state?.page === "apprenticeship" || state?.page === "vacancy" ? (
              <div className="apply-btn">
                <a
                  href={state?.data?.urlLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {state?.data?.urlLink && (
                    <button disabled={disable} className="applyButton"
                      style={{ marginTop: isSmallScreen && "10px" }}
                    >
                      Apply
                    </button>
                  )}
                </a>
              </div>
            ) : null}
          </div> */}
        </Card>
      </div>
    </motion.div>
  );
};

export default InfoCard;